import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import {AnimationOnScroll} from "react-animation-on-scroll";
import {Col, Row } from "react-bootstrap";
// import CustomButton from "../../components/CustomButton";
// import {FormStyled} from "./contact.styled";
import styled from 'styled-components';
import {ToastContainer,toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';


const ContactMapFormBlock = () => {
  return (
    <Row>
      <Col lg={6} className="my-2">
        <AnimationOnScroll animateIn={`${"animate__fadeInLeft"}`}>
          {/* <Map /> */}
        </AnimationOnScroll>
      </Col>
      <Col lg={6} className="my-2">
        <AnimationOnScroll animateIn={`${"animate__fadeInRight"}`}>
          {/* <ContactForm /> */}
        </AnimationOnScroll>
      </Col>
    </Row>
  );
};

function Map() {
  return (
    <div className="google-map">
      <div
        className="mapouter"
        style={{
          position: "relative",
          textAlign: "right",
          minHeight: "300px",
          width: "100%",
        }}
      >
        <div
          className="gmap_canvas"
          style={{
            overflow: "hidden",
            background: " none !important",
            height: "100%",
            width: "100%",
          }}
        >
        <iframe
  title="This is a unique title"
  width="100%"
  height="100%"
  id="gamp_canvas"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.1134501847046!2d66.98701857602768!3d24.96225444117556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb36bdc31a7de9d%3A0x1483d1492203872e!2sNAJAM%20TECHNO!5e0!3m2!1sen!2s!4v1686411036360!5m2!1sen!2s"
  style={{minHeight: "500px"}}
/>
        </div>
      </div>
    </div>
  );
}


function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
  
    emailjs
      .sendForm(
        "service_7neljlr",
        "template_xl7s4rm",
        form.current,
        "hwql1k5_RIZEV0QR8"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
          toast.success("Email sent successfully!");

          // Reset the form fields after the email is sent
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
          toast.error("Error sending email. Please try again later.");
        }
      );
  };

  return (
    <StyledContactForm>
      <form ref={form} onSubmit={sendEmail}>
        <label>Name *</label>
        <input type="text" name="user_name" required />
        <label>Email *</label>
        <input type="email" name="user_email" required />
        <label>Message *</label>
        <textarea name="message" required></textarea>
        <input type="submit" value="Send" />
      </form>
      <ToastContainer />
    </StyledContactForm>
  );
}

export default ContactMapFormBlock;


const StyledContactForm = styled.div`
  width: 100%;
  form {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    font-size: 16px;
    input {
      width: 100%;
      height: 60px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);
      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }
    textarea {
      width: 100%; /* Set your desired width in pixels */
      height: 150px; /* Set your desired height in pixels */
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);
      
      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }
    
    label {
      margin-top: 1rem;
    }
    input[type="submit"] {
      margin-top: 2rem;
      cursor: pointer;
      background: rgb(58, 206, 39);
      color: white;
      border: none;
    }
  }
`;


// function ContactForm() {
 
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();
  
//     const name = form.current.elements["user_name"].value;
//     const email = form.current.elements["user_email"].value;
//     const message = form.current.elements["message"].value;
  
//     if (name && email && message) {
//       emailjs
//         .sendForm(
//           "service_6bop5xa",
//           "template_qki110l",   
//           form.current,
//           "KEpGe-frD9HY89dx9"
//         )
//         .then(
//           (result) => {
//             console.log(result.text);
//             console.log("message sent");
//             toast.success("Email sent successfully!");
//           },
//           (error) => {
//             console.log(error.text);
//             toast.error("Error sending email. Please try again later.");
//           }
//         );
//     } else {
//       toast.error("Please fill in all required fields.");
//     }
//   };

 
//   return (
//     <StyledContactForm>
//     <form ref={form} onSubmit={sendEmail}>
//       <label>Name</label>
//       <input type="text" name="user_name" />
//       <label>Email</label>
//       <input type="email" name="user_email" />
//       <label>Message</label>
//       <textarea name="message" />
//       <input type="submit" value="Send" />
//     </form>
//     <ToastContainer />
//   </StyledContactForm>
//   );
// }

// export default ContactMapFormBlock;


// const StyledContactForm = styled.div`
//   width: 400px;
//   form {
//     display: flex;
//     align-items: flex-start;
//     flex-direction: column;
//     width: 100%;
//     font-size: 16px;
//     input {
//       width: 150%;
//       height: 60px;
//       padding: 7px;
//       outline: none;
//       border-radius: 5px;
//       border: 1px solid rgb(220, 220, 220);
//       &:focus {
//         border: 2px solid rgba(0, 206, 158, 1);
//       }
//     }
//     textarea {
//       // max-width: 100%;
//       min-width: 100%;
//       width: 150%;
//       max-height: 150px;
//       min-height: 100px;
//       padding: 7px;
//       outline: none;
//       border-radius: 5px;
//       border: 1px solid rgb(220, 220, 220);
//       &:focus {
//         border: 2px solid rgba(0, 206, 158, 1);
//       }
//     }
//     label {
//       margin-top: 1rem;
//     }
//     input[type="submit"] {
//       margin-top: 2rem;
//       cursor: pointer;
//       background: rgb(58, 206, 39);
//       color: white;
//       border: none;
//     }
//   }
// `;

// function ContactForm() {
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();
  
//     emailjs
//       .sendForm(
//         "service_6bop5xa",
//         "template_qki110l",
//         form.current,
//         "KEpGe-frD9HY89dx9"
//       )
//       .then(
//         (result) => {
//           console.log(result.text);
//           console.log("message sent");
//           toast.success("Email sent successfully!");

//           // Reset the form fields after the email is sent
//           form.current.reset();
//         },
//         (error) => {
//           console.log(error.text);
//           toast.error("Error sending email. Please try again later.");
//         }
//       );
//   };

//   return (
//     <StyledContactForm>
//       <form ref={form} onSubmit={sendEmail}>
//         <label>Name</label>
//         <input type="text" name="user_name" />
//         <label>Email</label>
//         <input type="email" name="user_email" />
//         <label>Message</label>
//         <textarea name="message" />
//         <input type="submit" value="Send" />
//       </form>
//       <ToastContainer />
//     </StyledContactForm>
//   );
// }

// export default ContactMapFormBlock;


// const StyledContactForm = styled.div`
//   width: 400px;
//   form {
//     display: flex;
//     align-items: flex-start;
//     flex-direction: column;
//     width: 100%;
//     font-size: 16px;
//     input {
//       width: 150%;
//       height: 60px;
//       padding: 7px;
//       outline: none;
//       border-radius: 5px;
//       border: 1px solid rgb(220, 220, 220);
//       &:focus {
//         border: 2px solid rgba(0, 206, 158, 1);
//       }
//     }
//     textarea {
//       // max-width: 100%;
//       min-width: 100%;
//       width: 150%;
//       max-height: 150px;
//       min-height: 100px;
//       padding: 7px;
//       outline: none;
//       border-radius: 5px;
//       border: 1px solid rgb(220, 220, 220);
//       &:focus {
//         border: 2px solid rgba(0, 206, 158, 1);
//       }
//     }
//     label {
//       margin-top: 1rem;
//     }
//     input[type="submit"] {
//       margin-top: 2rem;
//       cursor: pointer;
//       background: rgb(58, 206, 39);
//       color: white;
//       border: none;
//     }
//   }
// `;


